export function formatDate(date: Date | string): string {
  return new Date(date.toString()).toLocaleString('en-US', {
    timeZone: 'UTC',
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
  });
}
